import { render } from "./AccountSettings.vue?vue&type=template&id=23f83432&scoped=true"
import script from "./AccountSettings.vue?vue&type=script&lang=js"
export * from "./AccountSettings.vue?vue&type=script&lang=js"

import "./AccountSettings.vue?vue&type=style&index=0&id=23f83432&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f83432"]])

export default __exports__